import React from 'react';
import PropTypes from 'prop-types';
import * as styles from 'src/uglib_styles/notices.module.css'

function Notices (props) {
	
	return (<>
		<div className={styles.notices} >
			{props.children}
		</div>
	</>)
	
}

Notices.propTypes = {
	children: PropTypes.node.isRequired,
	flavour: PropTypes.string,
}

Notices.defaultProps = {
	flavour: "row"
}


export default Notices